<template>
  <div class="except_box">
    <van-nav-bar
      :title="$route.meta.title"
      :border="false"
      left-arrow
      @click-left="backToLast"
    >
      <template #left>
        <img class="black_back_img" src="@/assets/home/black_back.png" />
      </template>
    </van-nav-bar>
    <div class="good_info">
      <img class="good_pic" src="" />
      <div class="good_construct">
        <div class="good_title">
          越南进口大芒果大青芒新鲜热带水果10斤当越南进口大芒果大青芒新鲜热带水果10斤当越南进口大芒果大青芒新鲜热带水果10斤当
        </div>
        <div class="good_size">规格：10斤 共1件</div>
        <div class="good_price">¥50</div>
      </div>
    </div>
    <div class="reason_box">
      <common-title title="投诉原因" :hiddenBottomLine="true"></common-title>
      <div class="list_box">
        <div
          class="reason_list"
          v-for="(item, index) in reasonList"
          :key="index"
          @click="selectReason(index)"
        >
          <div class="reason_text">{{ item }}</div>
          <img
            v-if="selectedIdx == index"
            class="reason_img"
            src="@/assets/order/selected.png"
          />
          <img v-else class="reason_img" src="@/assets/order/unselected.png" />
        </div>
      </div>
    </div>
    <div class="other_reason">
      <van-field
        class="remark_input"
        v-model="otherReason"
        type="textarea"
        placeholder="其他投诉原因可在此详细描述"
        autosize
      ></van-field>
    </div>
    <div class="btn" @click="submit">提交</div>
  </div>
</template>

<script>
import navBar from "@/components/nav-bar.vue";
import commonTitle from "@/components/common_title.vue";
export default {
  components: {
    navBar,
    commonTitle,
  },
  data() {
    return {
      reasonList: [
        "发货问题（含延迟发货/缺货/虚假发货等）",
        "恶意骚扰（频繁骚扰/辱骂/诅咒/威胁）",
        "商品问题（含质量问题/缺货/虚假发货）",
        "卖家态度不好（不忍/被拉黑等）",
        "卖家拒绝履行承诺（含发票/赠品/换货等）",
        "其他",
      ],
      selectedIdx: null,
      otherReason: "",
    };
  },
  methods: {
    submit() {
      console.log("提交异常");
    },
    selectReason(index) {
      this.selectedIdx = index;
    },
    backToLast() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.except_box {
  //   padding-top: vw(88);
  .black_back_img {
    width: vw(35);
    height: vw(33);
  }
  .good_info {
    // margin-left: vw(30);
    // margin-right: vw(30);
    padding: vw(20) vw(30);
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: vw(1) #eef0f3 solid;
    .good_pic {
      width: vw(230);
      height: vw(230);
      border-radius: vw(8);
    }
    .good_construct {
      margin-left: vw(30);
      .good_title {
        color: #333333;
        font-size: vw(32);
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .good_size {
        margin-top: vw(16);
        color: #666666;
        font-size: vw(26);
      }
      .good_price {
        margin-top: vw(40);
        color: #333333;
        font-size: vW(32);
      }
    }
  }
  .reason_box {
    .list_box {
      margin-left: vw(30);
      margin-right: vw(30);
      display: flex;
      flex-direction: column;
      .reason_list {
        padding-top: vw(20);
        padding-bottom: vw(20);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .reason_text {
          color: #333333;
          font-size: vw(28);
        }
        .reason_img {
          width: vw(32);
          height: vw(32);
        }
      }
    }
  }
  .other_reason {
    margin-top: vw(20);
    margin-left: vw(30);
    margin-right: vw(30);
    border-radius: vw(8);
    .remark_input {
      background-color: #f4f6f9;
    }
  }
  .btn {
    color: #ffffff;
    font-size: vw(30);
    margin-top: vw(67);
    margin-left: vw(30);
    margin-right: vw(30);
    height: vw(88);
    line-height: vw(88);
    text-align: center;
    border-radius: vw(8);
    background-color: $theme-color;
  }
}
</style>
